export class tourResponseType{
    public static POPUNI_ARTIKAL: number = 1;
    public static SAVE_ITEM: number = 2;
}